import { gql } from '@grandvisionhq/graphql';
import { shoppinglistProductOverviewFragment } from '../fragments/shopping-list.js';

const failureFragment = gql`
  fragment ShoppinglistFailureFragment on ShoppinglistByIdFailure {
    ... on ShoppinglistNotFoundFailure {
      message
    }
    ... on ShoppinglistAuthorizationFailure {
      message
    }
    ... on ShoppinglistValidationFailure {
      message
    }
    ... on ShoppinglistFailure {
      message
    }
  }
`;
var GET_SHOPPING_LIST_BY_ID = gql`
  query getShoppingListById($shoppinglistId: String!) {
    shoppinglistById(shoppinglistId: $shoppinglistId) {
      shoppinglist {
        ...ShoppinglistProductOverviewFragment
      }
      failure {
        ...ShoppinglistFailureFragment
      }
    }
  }
  ${shoppinglistProductOverviewFragment}
  ${failureFragment}
`;

export { GET_SHOPPING_LIST_BY_ID as default, failureFragment };
//# sourceMappingURL=get-shopping-list-by-id-product.js.map
